import { Box, Stack, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { IconButton, PlusIcon } from '@tom-ui/ui'
import { useYardStores } from '@yard/AppProvider'
import { observer } from 'mobx-react-lite'
import { DragDropContext, Droppable, DropResult } from 'react-beautiful-dnd'
import {
  AllocationDestinationSubFormType,
  AllocationRuleFormStore,
} from '../../stores/allocation-rule.form-store'
import { DestinationItemOverview } from '../molecules/DestinationItemOverview'
import { AllocationRuleDestinationDialog } from './AllocationRuleDestinationDialog'

interface Props {
  formStore: AllocationRuleFormStore
  destinations: AllocationDestinationSubFormType[]
}
export const AllocationRuleDestinationsForm = observer(({ formStore, destinations }: Props) => {
  const { t } = useTranslate()
  const { yardBlockStore } = useYardStores()

  const handleDragEnd = (result: DropResult) => {
    if (!result.destination) return
    formStore.reorderDestinations(result.source.index, result.destination.index)
  }

  return (
    <Box>
      <Stack direction='row' justifyContent='space-between' alignItems='center' mb={2}>
        <Typography variant='h4'>{t('destinations', 'Destinations')}</Typography>
        <IconButton
          onClick={() => formStore.toggleUpsertDestinationDialog()}
          data-cy='destination-add-button'
        >
          <PlusIcon />
        </IconButton>
      </Stack>

      <AllocationRuleDestinationDialog
        isOpen={formStore.isUpsertDestinationDialogOpen}
        yardBlocks={yardBlockStore.items}
        position={formStore.destinationBlockRange}
        hasError={formStore.destinationDialogHasError}
        onClose={() => formStore.toggleUpsertDestinationDialog()}
        onConfirm={() => {
          formStore.saveDestination()
        }}
        onPositionChange={position => formStore.setDestinationBlockRange(position)}
      />

      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId='destinationsList'>
          {provided => (
            <Box {...provided.droppableProps} ref={provided.innerRef}>
              {destinations.map((destination, index) => (
                <DestinationItemOverview
                  key={`destination-${index}`}
                  id={index}
                  index={index}
                  yardBlocks={yardBlockStore.items}
                  yardBlock={yardBlockStore.yardBlocks[destination.blockId.value]}
                  minBay={destination.minBay.value}
                  maxBay={destination.maxBay.value}
                  minRow={destination.minRow.value}
                  maxRow={destination.maxRow.value}
                  onEdit={() => formStore.toggleUpsertDestinationDialog(index)}
                  onDelete={() => formStore.deleteDestination(index)}
                />
              ))}
              {provided.placeholder}
            </Box>
          )}
        </Droppable>
      </DragDropContext>
    </Box>
  )
})
